import renderDom from './lib/render/dom';

export function initClient (App, opts) {
    return renderDom(App, opts);
}

export default initClient;
